import {Skeleton} from '@sollapay/ui';

import {LegalContainer} from './LegalContainer';

import type {FC} from 'react';

export const LegalDocumentSkeleton: FC = () => {
  return (
    <div data-slot="legal-document-skeleton" aria-hidden="true">
      <div className="border-b border-border bg-background-selected">
        <LegalContainer className="flex flex-col items-start gap-3 py-8">
          <Skeleton className="size-12 rounded-full" />
          <div className="flex w-full flex-col gap-2">
            <Skeleton className="h-7 w-2/3" />
            <Skeleton className="h-4 w-1/3" />
          </div>
        </LegalContainer>
      </div>
      <LegalContainer className="flex flex-col gap-3 py-10">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/6" />
      </LegalContainer>
    </div>
  );
};
